import { render, staticRenderFns } from "./BinanceFuturesMarketPrice.vue?vue&type=template&id=2c4b8c6f&"
import script from "./BinanceFuturesMarketPrice.vue?vue&type=script&lang=js&"
export * from "./BinanceFuturesMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports